import React, { useEffect, useMemo, useState } from 'react';
import { CustomSelect } from 'web-library';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import FormControl from 'web-library/stories/atom/FormControl/FormControl';
import { MenuItems } from './model';
import { KeyValueResponse } from '../../api';
import { useGetPaymentModeOptions } from '../../api/candidate/resit/@opadmin/queries-services/queries';
import { SelectChangeEvent } from '@mui/material';

const useStyles = makeStyles()((theme) =>
({
  fromControlContainer: {
    display: 'flex',
    marginBottom: theme.spacing(3),
    width: '100%'
  },
}));

export interface SchoolCodeMultiSelectProps {
  /** to handle select on change event
   * */
  onChange?: (event: KeyValueResponse[]) => void;

  /** to define select control selected value
   * */
  value: string[];

  /** to define option label
   * * */
  label: string;
}

/** reusable select component for school code option
 * */
const PaymentModeMultiSelect: React.FC<SchoolCodeMultiSelectProps> = (
  props: SchoolCodeMultiSelectProps
) => {
  const { label, value = [], onChange = (event: KeyValueResponse[]) => {
    // do nothing
  } } = props;
  const [paymentModes, setPaymentModes] = useState<KeyValueResponse[]>([]);

  const { classes } = useStyles();

  const { refetch } = useGetPaymentModeOptions({
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    onSuccess: (responseData) => {
      if (responseData && responseData.length > 0) {
        setPaymentModes(responseData);
      }
    },
  });

  /** reform data into CustomSelect MenuItems
   * */
  const dropDownData = useMemo<MenuItems[]>(() => {
    if (!paymentModes) {
      return [];
    }
    return paymentModes.map((option) => ({
      children: option.description,
      value: option.code,
      key: `k-${option.code}`,
    }));
  }, [paymentModes]);

  /** handle select on Change
   * */
  const onSelectOptionChange = async (selectedValue: any[] | unknown) => {
    if (paymentModes && paymentModes.length > 0 && Array.isArray(selectedValue)) {
      onChange(paymentModes.filter(payment => selectedValue.includes(payment.code)));
    }
  };

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <FormControl className={classes.fromControlContainer}>
      <CustomSelect
        displayEmpty
        variant="filled"
        multiple
        label={label}
        labelId="inputSelectLabel-paymentModeOptions"
        id="inputSelect-paymentModeOptions"
        onChange={(e: SelectChangeEvent<unknown>) => {
          onSelectOptionChange(e.target.value);
          window.dispatchEvent(new CustomEvent('resize'));
        }}
        menuItems={dropDownData}
        value={value}
        renderValue={(selected: unknown | string[]) =>
          Array.isArray(selected) && selected.length > 0
            ? paymentModes
              .filter((paymentMode) => selected.includes(paymentMode.code))
              .map((s) => s.description)
              .join(', ')
            : 'Select Payment'
        }
      />
    </FormControl>
  );
};
export default PaymentModeMultiSelect;
